import { render, staticRenderFns } from "./NormalSearchNav325.vue?vue&type=template&id=bfa0923c&scoped=true&"
import script from "./NormalSearchNav325.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav325.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa0923c",
  null
  
)

export default component.exports